<template>
    <UILoader v-if="isUserLoading || isDealersLoading" class="modalable" />

    <div v-else class="user-modal">
        <div class="user-modal__header">
            <div class="user-modal__name">
                {{ user?.full_name }}
            </div>

            <router-link
                v-if="user"
                :to="{ name: 'EditUser', params: { user_id: user.id } }"
                class="user-modal__menu"
            >
                <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
            </router-link>
        </div>

        <div class="user-modal__info-sync">Информация о профиле синхронизирована с системой Hyundai ID.</div>

        <div class="user-modal__body">
            <div class="user-modal__details">
                <div class="user-modal__detail">
                    <div class="user-modal__detail-label">Email</div>
                    <div class="user-modal__detail-value">
                        {{ user?.email }}
                    </div>
                </div>

                <div class="user-modal__detail">
                    <div class="user-modal__detail-label">Телефон</div>
                    <div class="user-modal__detail-value">
                        {{ user?.phone ? user?.phone : '-' }}
                    </div>
                </div>

                <div class="user-modal__detail">
                    <div class="user-modal__detail-label">Роль</div>
                    <div class="user-modal__detail-value">
                        {{ user?.is_admin ? 'Администратор' : 'Пользователь' }}
                    </div>
                </div>

                <div class="user-modal__detail">
                    <div class="user-modal__detail-label">Статус</div>
                    <div class="user-modal__detail-value">
                        {{ user?.status ? getUserStatusLabel(user?.status) : '-' }}
                    </div>
                </div>
            </div>

            <div class="user-modal__table">
                <DataTable
                    :headers="headers"
                    :data="userDealers"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, onMounted } from 'vue';

    import { DealerListItem } from '@/types/dealer.type.ts';
    import { getUserStatusLabel, User } from '@/types/user.type.ts';

    import useLoading from '@/utils/useLoading.ts';
    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    import DataTable from '@/components/shared/DataTable/DataTable.vue';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';

    const { userId } = defineProps<{ userId: number }>();

    const { getUser, getUserDealers } = useUserRepository();
    const { isLoading: isUserLoading, setLoading: setUserLoading } = useLoading();
    const { isLoading: isDealersLoading, setLoading: setDealersLoading } = useLoading();

    const user = ref<User | null>(null);
    const userDealers = ref<DealerListItem[]>([]);
    const headers = ref([
        { label: 'Код дилера', key: 'sap_code' },
        { label: 'Название ДЦ', key: 'name', sortable: true },
        { label: 'Холдинг', key: 'holding_name' },
        { label: 'Город', key: 'city_name' },
    ]);

    function fetchUserDealers(): void {
        setDealersLoading(true);

        getUserDealers(userId).then((fetchedUserDealers: DealerListItem[]) => {
            userDealers.value = fetchedUserDealers;
            setDealersLoading(false);
        });
    }

    function fetchUser(): void {
        setUserLoading(true);

        getUser(userId).then((fetchedUser: User) => {
            user.value = fetchedUser;
            setUserLoading(false);
        });

        fetchUserDealers();
    }

    onMounted(async () => {
        fetchUser();
    });
</script>

<style scoped lang="scss">
    @use 'UserModal' as *;
</style>
